import React from "react";
import ProtectedRoute from "./ProtectedRoute";

// AdminRoute component to guard routes that require ADMIN role
const AdminRoute = ({ children }) => {
    return (
        <ProtectedRoute requiredRole="ADMIN">
            {children}
        </ProtectedRoute>
    );
};

export default AdminRoute;
